export default {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Thank you for your information!',
        MESSAGE: 'The reference information you submitted is very important for us. You can safely close this window now.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: `
        <h2>Thank you for submitting your registration!</h2>
        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>
        `
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: `
        <h2>Video is uploaded successfully!</h2>
        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style='position: absolute;'>refresh</i>&nbsp;&nbsp;) button</h5>
        `
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the client and candidate notification.'
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} nannies!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/result-dialog/de.js